import CalculatedDetailsInterface from '@/utilities/bid/cost/Interfaces/CalculatedDetailsInterface'
import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import Calculation from '@/utilities/bid/cost/Calculation'
import CalculationResultInterface from '@/utilities/bid/cost/Interfaces/CalculationResultInterface'
import CollectionEnum from '@/utilities/bid/cost/enums/CollectionEnum'

class SummaryTotals {
  details: CalculatedDetailsInterface

  constructor(details: CalculatedDetailsInterface) {
    this.details = details
  }

  getCost(reference: string, collection: Array<CollectionInterface>): CalculationResultInterface {
    const calculation = new Calculation(collection)
    calculation.all()
    return calculation.getResults(reference)
  }

  getAll() {
    return [
      this.getCost(CollectionEnum.LABOUR, this.details.labour),
      this.getCost(CollectionEnum.PROCESSING, this.details.processing),
      this.getCost(CollectionEnum.EXPENSES, this.details.expenses),
      this.getCost(CollectionEnum.ADDITIONAL, this.details.additional),
    ]
  }
}

export default SummaryTotals
